<template>
	<ja-modal v-if="formData" :show="show" class="export-data-modal">
		<ja-close-button name="close" @click.native="closeModal"></ja-close-button>

		<div v-if="showWarning" class="modal-content">
			<div class="warning-message">
				<div class="import-result-imported">
					{{ $t('exportDataWarning') }}
				</div>
			</div>

			<div class="button-wrapper">
				<ja-button class="small" name="agreeButton" @click.native="agree"
					>{{ $t('yes') }}
				</ja-button>
				<ja-button
					class="small btn-right"
					name="disagreeButton"
					@click.native="disagree"
				>
					{{ $t('no') }}
				</ja-button>
			</div>
		</div>

		<div v-if="agreed" class="modal-content">
			<!-- <perfect-scrollbar class="scrollbar" :watch-options="true"> -->
			<h3 class="title">{{ $t('exportData') }}</h3>
			<div class="grid">
				<div class="grid-row-2">
					<ja-dropdown
						ref="modalFirstDropdown"
						v-model="formData.facility"
						:label="$t('facilityLbl')"
						:options="facilities"
						name="facility"
						@input="choiceUpdated"
					></ja-dropdown>
				</div>
			</div>
			<div class="button-wrapper">
				<ja-button
					class="small"
					name="startExport"
					:success="success"
					@click.native="startExport"
					>{{ $t('export') }}</ja-button
				>
			</div>
		</div>
	</ja-modal>
</template>
<script>
import Modal from '@/components/Modal/Modal';
import Dropdown from '../../ui/form/Dropdown';
import Button from '../../ui/Button';
import UserData from '@/mixins/UserData';
import DateFormat from '@/mixins/DateFormat';
import CloseButton from '../../ui/CloseButton';
import axios from 'axios';

export default {
	components: {
		jaDropdown: Dropdown,
		jaButton: Button,
		jaModal: Modal,
		jaCloseButton: CloseButton
	},
	mixins: [UserData, DateFormat],

	props: {
		show: {
			type: Boolean,
			default: false
		},
		facilities: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			formData: null,
			success: false,
			failure: false,
			message: null,
			showWarning: true,
			agreed: false
		};
	},
	computed: {},
	watch: {},
	mounted() {
		this.setupModalData();
	},
	methods: {
		closeModal() {
			this.$emit('closeModal');
		},
		setupModalData() {
			const formData = {
				wholeArea: false,
				facilityName: this.facilities[0].name,
				facilityId: this.facilities[0].value
			};

			formData.facility = 0;

			this.formData = formData;
		},
		choiceUpdated() {
			let choice = this.facilities[this.formData.facility];

			if (!choice.value) {
				// user chose Whole Area
				this.formData.wholeArea = true;
				this.formData.facilityId = null;
			} else {
				this.formData.wholeArea = false;
				this.formData.facilityName = choice.name;
				this.formData.facilityId = choice.value;
			}
		},
		startExport() {
			if (this.success) {
				this.closeModal();
			} else {
				this.$emit('loadingStartForAdmin');
				axios({
					url: '/api/Data/ExportData',
					method: 'GET',
					params: {
						facilityId: this.formData.facilityId,
						facilityName: this.formData.facilityName,
						wholeArea: this.formData.wholeArea
					},
					withCredentials: true
				}).then(response => {
					if (response.data) {
						this.success = true;
					} else {
						this.failure = true;
					}

					this.$emit('loadingStopForAdmin');
				});
			}
		},
		agree() {
			this.showWarning = false;
			this.agreed = true;
		},
		disagree() {
			this.closeModal();
		}
	}
};
</script>
<style lang="scss" scoped>
.export-data-modal {
	::v-deep .modal {
		margin: auto;
		min-height: 240px;
		max-height: 768px;
		top: unset;
	}
	::v-deep.modal-content {
		border-radius: 8px;
	}
	.close-button {
		background-color: $font-blue;
		position: absolute;
		height: 38px;
		width: 38px;
		right: 16px;
		top: 16px;
		outline: 0;
		border: 0;
		background-color: $container-bgcolor;
		@media (any-hover: hover) {
			&:hover {
				cursor: pointer;
				svg {
					fill: $hover-state;
				}
			}
		}

		svg {
			fill: $primary-state;
		}
	}

	.modal-content {
		.scrollbar {
			max-height: 720px;
		}
		height: 100%;
		width: 100%;
		padding-top: 24px;
		display: flex;
		flex-direction: column;
		text-align: left;
		background-color: $container-bgcolor;
		border: 1px solid $container-border;

		h3 {
			margin: 16px;
			text-align: center;
		}

		.grid {
			display: flex;
			flex-direction: column;
			padding: 0 32px 32px 32px;

			.grid-row-1 {
				display: flex;
				margin-bottom: 16px;
				> * {
					flex: 0 0 100%;
				}
			}

			.grid-row-2 {
				display: flex;
				align-items: flex-start;

				&:not(:last-child) {
					margin-bottom: 16px;
				}

				> * {
					flex: 0 0 calc(50% - 8px);

					&:first-child {
						margin-right: 16px;
					}
				}
				&.align-bottom {
					align-items: flex-end;
				}
			}

			.grid-col-3 {
				display: flex;
				align-items: flex-end;

				> :first-child {
					margin-right: 16px;
				}

				.grid-cell-2 {
					flex: 0 0 calc(66.66% - 8px);
				}

				.grid-cell-1 {
					flex: 0 0 calc(33.33% - 8px);
				}
			}
		}

		.import-result-container {
			display: flex;
			justify-content: center;
			.import-result-imported,
			.import-result-failed {
				font-family: 'RobotoMedium';
				color: #004cd0;
				margin-bottom: 8px;
				letter-spacing: 0.5px;
				@media (min-width: $breakpoint-mid) {
					font-size: 18px;

					.svg-icon {
						width: 24px;
						height: 24px;
					}
				}
				.svg-icon {
					margin-right: 10px;
				}
			}
			.import-result-failed {
				color: #f93457;
				margin-left: 10px;

				font-family: 'RobotoMedium';
				color: #004cd0;
				margin-top: 48px;
				margin-bottom: 8px;
				letter-spacing: 0.5px;
				@media (min-width: $breakpoint-mid) {
					font-size: 18px;

					.svg-icon {
						width: 24px;
						height: 24px;
					}
				}
				.svg-icon {
					margin-right: 10px;
				}
			}
		}

		.warning-message {
			display: flex;
			justify-content: center;
			font-family: 'RobotoMedium';
			color: #283eff;
			margin-bottom: 38px;
			letter-spacing: 0.5px;
			padding: 50px 60px 0 60px;
			text-align: center;

			@media (min-width: $breakpoint-mid) {
				font-size: 18px;
			}
		}

		.button-wrapper {
			text-align: center;
			margin-bottom: 64px;

			.btn-right {
				margin-left: 20px;
			}
		}
	}
}
</style>
